import { render, staticRenderFns } from "./Withdraw.vue?vue&type=template&id=2bd78857&scoped=true"
import script from "./Withdraw.vue?vue&type=script&lang=js"
export * from "./Withdraw.vue?vue&type=script&lang=js"
import style0 from "./Withdraw.vue?vue&type=style&index=0&id=2bd78857&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd78857",
  null
  
)

export default component.exports